import React, { useState } from "react";

// chakra ui
import {
  Box,
  Checkbox,
  Flex,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
} from "@chakra-ui/react";

// common component
import { ButtonWrapper } from "ui";
import { StorageService } from "services/storage.service";

// config
import { config } from "config/config";

// firebase analytics
import useHashConnect from "hooks/useHashConnect";
import { firebaseEvents } from "utils/firebase";
import { FIREBASE_EVENT_PROPERTIES } from "constants/constants";

function BuyHbar() {
  const [agreeCheckbox, setAgreeCheckbox] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const baxanaTermAccepted = StorageService.isBanxaTermsAccepted();
  const { selectedAccount, walletData } = useHashConnect();
  const sendLog = (name: string) => {
    let firebaseRequest: any = {
      [FIREBASE_EVENT_PROPERTIES.EVENT_NAME]: "Join_our_community",
      [FIREBASE_EVENT_PROPERTIES.JOC_TYPE]: name,
      [FIREBASE_EVENT_PROPERTIES.WALLET_NAME]:
        walletData.pairedWalletData?.name,
      [FIREBASE_EVENT_PROPERTIES.WALLET_ADDRESS]: selectedAccount,
    };
    firebaseEvents(firebaseRequest);
  };
  const redirectToWebsite = () => {
    window.open(config.hbar_buy_url, "_blank");
    onClose();
  };

  const body = (
    <Flex alignItems="center" flexDirection="column" mb="20px">
      <Text
        textAlign="center"
        fontSize="16px"
        fontWeight="400"
        color="brand.textInactive"
        px="44px"
        m="0"
      >
        You are being directed to a third-party platform. Please be aware that
        the new platform may have risks and terms different from those of
        Stader. Stader does not have the ability to verify the platform or
        ascertain the risks associated with it. Users are advised to proceed at
        their own risk and assess the security, and terms of service of the new
        platform independently before transacting
      </Text>
      <Box py="1.8rem" marginBottom="0.5rem" borderRadius="0.5rem">
        <Checkbox
          checked={agreeCheckbox}
          as="span"
          border="2px"
          borderRadius="4px"
          borderColor="brand.primary"
          mt="2px"
          onChange={(e) => {
            setAgreeCheckbox(e.target.checked);
          }}
        />

        <Text fontSize="12px" ml="8px" as="span" fontWeight="400">
          I understand the risk and wish to proceed
        </Text>
      </Box>

      <ButtonWrapper
        bg="brand.primary"
        textColor="brand.textLight"
        onClick={() => {
          StorageService.setBanxaTermsAccepted(true);
          redirectToWebsite();
        }}
        disabled={!agreeCheckbox}
        w="128px"
        h="52px"
        mb="20px"
      >
        <Box py=".5rem" fontSize="16px">
          Ok
        </Box>
      </ButtonWrapper>
    </Flex>
  );

  return (
    <Box>
      <ButtonWrapper
        backgroundColor="brand.backgroundLight"
        fontSize="1rem"
        py="0.75rem"
        px="2.81rem"
        h="3rem"
        _hover={{}}
        onClick={() => {
          if (baxanaTermAccepted) {
            sendLog("Buy_token");
            redirectToWebsite();
          } else {
            setAgreeCheckbox(false);
            onOpen();
          }
        }}
      >
        <Box py=".5rem">Buy HBAR</Box>
      </ButtonWrapper>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent maxW="720px" bg="brand.backgroundLight">
          <ModalHeader
            textAlign="center"
            mt="50px"
            mb="24px"
            fontSize="32px"
            fontWeight="700"
          >
            Disclaimer
          </ModalHeader>
          <ModalCloseButton onClick={() => onClose()} mt="54px" mr="44px" />
          <ModalBody m="0" p="0">
            {body}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
}

export default BuyHbar;
